// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Apply = require("../Control.Apply/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Monad_Free = require("../Control.Monad.Free/index.js");
var Control_Monad_State_Class = require("../Control.Monad.State.Class/index.js");
var Control_Semigroupoid = require("../Control.Semigroupoid/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Ordering = require("../Data.Ordering/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Time_Duration = require("../Data.Time.Duration/index.js");
var Data_Traversable = require("../Data.Traversable/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Effect = require("../Effect/index.js");
var Effect_Aff = require("../Effect.Aff/index.js");
var Effect_Aff_AVar = require("../Effect.Aff.AVar/index.js");
var Effect_Aff_Class = require("../Effect.Aff.Class/index.js");
var Effect_Class = require("../Effect.Class/index.js");
var Effect_Exception = require("../Effect.Exception/index.js");
var Effect_Ref = require("../Effect.Ref/index.js");
var Halogen_Component = require("../Halogen.Component/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_Query = require("../Halogen.Query/index.js");
var Halogen_Query_HalogenM = require("../Halogen.Query.HalogenM/index.js");
var Record_Builder = require("../Record.Builder/index.js");
var Web_Event_Event = require("../Web.Event.Event/index.js");
var Web_HTML_HTMLElement = require("../Web.HTML.HTMLElement/index.js");
var Web_UIEvent_KeyboardEvent = require("../Web.UIEvent.KeyboardEvent/index.js");
var Web_UIEvent_MouseEvent = require("../Web.UIEvent.MouseEvent/index.js");
var Off = (function () {
    function Off() {

    };
    Off.value = new Off();
    return Off;
})();
var On = (function () {
    function On() {

    };
    On.value = new On();
    return On;
})();
var Prev = (function () {
    function Prev() {

    };
    Prev.value = new Prev();
    return Prev;
})();
var Next = (function () {
    function Next() {

    };
    Next.value = new Next();
    return Next;
})();
var Index = (function () {
    function Index(value0) {
        this.value0 = value0;
    };
    Index.create = function (value0) {
        return new Index(value0);
    };
    return Index;
})();
var Send = (function () {
    function Send(value0) {
        this.value0 = value0;
    };
    Send.create = function (value0) {
        return new Send(value0);
    };
    return Send;
})();
var Query = (function () {
    function Query(value0) {
        this.value0 = value0;
    };
    Query.create = function (value0) {
        return new Query(value0);
    };
    return Query;
})();
var Text = (function () {
    function Text() {

    };
    Text.value = new Text();
    return Text;
})();
var Toggle = (function () {
    function Toggle() {

    };
    Toggle.value = new Toggle();
    return Toggle;
})();
var Searched = (function () {
    function Searched(value0) {
        this.value0 = value0;
    };
    Searched.create = function (value0) {
        return new Searched(value0);
    };
    return Searched;
})();
var Selected = (function () {
    function Selected(value0) {
        this.value0 = value0;
    };
    Selected.create = function (value0) {
        return new Selected(value0);
    };
    return Selected;
})();
var VisibilityChanged = (function () {
    function VisibilityChanged(value0) {
        this.value0 = value0;
    };
    VisibilityChanged.create = function (value0) {
        return new VisibilityChanged(value0);
    };
    return VisibilityChanged;
})();
var Search = (function () {
    function Search(value0) {
        this.value0 = value0;
    };
    Search.create = function (value0) {
        return new Search(value0);
    };
    return Search;
})();
var Highlight = (function () {
    function Highlight(value0) {
        this.value0 = value0;
    };
    Highlight.create = function (value0) {
        return new Highlight(value0);
    };
    return Highlight;
})();
var Select = (function () {
    function Select(value0, value1) {
        this.value0 = value0;
        this.value1 = value1;
    };
    Select.create = function (value0) {
        return function (value1) {
            return new Select(value0, value1);
        };
    };
    return Select;
})();
var ToggleClick = (function () {
    function ToggleClick(value0) {
        this.value0 = value0;
    };
    ToggleClick.create = function (value0) {
        return new ToggleClick(value0);
    };
    return ToggleClick;
})();
var Focus = (function () {
    function Focus(value0) {
        this.value0 = value0;
    };
    Focus.create = function (value0) {
        return new Focus(value0);
    };
    return Focus;
})();
var Key = (function () {
    function Key(value0) {
        this.value0 = value0;
    };
    Key.create = function (value0) {
        return new Key(value0);
    };
    return Key;
})();
var PreventClick = (function () {
    function PreventClick(value0) {
        this.value0 = value0;
    };
    PreventClick.create = function (value0) {
        return new PreventClick(value0);
    };
    return PreventClick;
})();
var SetVisibility = (function () {
    function SetVisibility(value0) {
        this.value0 = value0;
    };
    SetVisibility.create = function (value0) {
        return new SetVisibility(value0);
    };
    return SetVisibility;
})();
var Initialize = (function () {
    function Initialize(value0) {
        this.value0 = value0;
    };
    Initialize.create = function (value0) {
        return new Initialize(value0);
    };
    return Initialize;
})();
var Action = (function () {
    function Action(value0) {
        this.value0 = value0;
    };
    Action.create = function (value0) {
        return new Action(value0);
    };
    return Action;
})();
var handleQuery = function (dictMonadAff) {
    return function (handleQuery$prime) {
        return function (v) {
            if (v instanceof Send) {
                return Halogen_Query_HalogenM.HalogenM(Control_Monad_Free.liftF(new Halogen_Query_HalogenM.ChildQuery(v.value0)));
            };
            if (v instanceof Query) {
                return handleQuery$prime(v.value0);
            };
            throw new Error("Failed pattern match at Select (line 207, column 28 - line 212, column 23): " + [ v.constructor.name ]);
        };
    };
};
var eqVisibility = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Off && y instanceof Off) {
            return true;
        };
        if (x instanceof On && y instanceof On) {
            return true;
        };
        return false;
    };
});
var handleAction = function (dictMonadAff) {
    return function (dictLacks) {
        return function (dictLacks1) {
            return function (dictLacks2) {
                return function (handleAction$prime) {
                    return function (handleEvent) {
                        var handle = function (act) {
                            return handleAction(dictMonadAff)()()()(handleAction$prime)(handleEvent)(act);
                        };
                        var getTargetIndex = function (st) {
                            var lastIndex = function ($79) {
                                return (function (v) {
                                    return v - 1 | 0;
                                })(st.getItemCount($79));
                            };
                            return function (v) {
                                if (v instanceof Index) {
                                    return v.value0;
                                };
                                if (v instanceof Prev) {
                                    if (st.highlightedIndex instanceof Data_Maybe.Just && st.highlightedIndex.value0 !== 0) {
                                        return st.highlightedIndex.value0 - 1 | 0;
                                    };
                                    return lastIndex(st);
                                };
                                if (v instanceof Next) {
                                    if (st.highlightedIndex instanceof Data_Maybe.Just && st.highlightedIndex.value0 !== lastIndex(st)) {
                                        return st.highlightedIndex.value0 + 1 | 0;
                                    };
                                    return 0;
                                };
                                throw new Error("Failed pattern match at Select (line 330, column 23 - line 337, column 13): " + [ v.constructor.name ]);
                            };
                        };
                        return function (v) {
                            if (v instanceof Initialize) {
                                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Effect_Ref["new"](Data_Maybe.Nothing.value)))(function (ref) {
                                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                        var $39 = {};
                                        for (var $40 in v1) {
                                            if ({}.hasOwnProperty.call(v1, $40)) {
                                                $39[$40] = v1[$40];
                                            };
                                        };
                                        $39.debounceRef = new Data_Maybe.Just(ref);
                                        return $39;
                                    }))(function () {
                                        return Data_Foldable.for_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(v.value0)(handleAction$prime);
                                    });
                                });
                            };
                            if (v instanceof Search) {
                                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (st) {
                                    return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Data_Functor.map(Effect.functorEffect)(Control_Bind.join(Data_Maybe.bindMaybe))(Data_Traversable.traverse(Data_Traversable.traversableMaybe)(Effect.applicativeEffect)(Effect_Ref.read)(st.debounceRef))))(function (ref) {
                                        return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                            var $43 = {};
                                            for (var $44 in v1) {
                                                if ({}.hasOwnProperty.call(v1, $44)) {
                                                    $43[$44] = v1[$44];
                                                };
                                            };
                                            $43.search = v.value0;
                                            return $43;
                                        }))(function () {
                                            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Halogen_Query_HalogenM.fork(handle(new SetVisibility(On.value)))))(function () {
                                                if (st.inputType instanceof Text && ref instanceof Data_Maybe.Nothing) {
                                                    return Data_Functor.voidRight(Halogen_Query_HalogenM.functorHalogenM)(Data_Unit.unit)(Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Aff_Class.liftAff(Halogen_Query_HalogenM.monadAffHalogenM(dictMonadAff))(Effect_Aff_AVar.empty))(function ($$var) {
                                                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Aff_Class.liftAff(Halogen_Query_HalogenM.monadAffHalogenM(dictMonadAff))(Effect_Aff.forkAff(Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Aff.delay(st.debounceTime))(function () {
                                                            return Effect_Aff_AVar.put(Data_Unit.unit)($$var);
                                                        }))))(function (fiber) {
                                                            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Halogen_Query_HalogenM.fork(Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Effect_Aff_Class.liftAff(Halogen_Query_HalogenM.monadAffHalogenM(dictMonadAff))(Effect_Aff_AVar.take($$var))))(function () {
                                                                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(Effect_Ref.write(Data_Maybe.Nothing.value))(st.debounceRef))))(function () {
                                                                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                                                        var $48 = {};
                                                                        for (var $49 in v1) {
                                                                            if ({}.hasOwnProperty.call(v1, $49)) {
                                                                                $48[$49] = v1[$49];
                                                                            };
                                                                        };
                                                                        $48.highlightedIndex = new Data_Maybe.Just(0);
                                                                        return $48;
                                                                    }))(function () {
                                                                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (newState) {
                                                                            return handleEvent(new Searched(newState.search));
                                                                        });
                                                                    });
                                                                });
                                                            }))))(function () {
                                                                return Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(Effect_Ref.write(new Data_Maybe.Just({
                                                                    "var": $$var,
                                                                    fiber: fiber
                                                                })))(st.debounceRef)));
                                                            });
                                                        });
                                                    }));
                                                };
                                                if (st.inputType instanceof Text && ref instanceof Data_Maybe.Just) {
                                                    return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Effect_Aff_Class.liftAff(Halogen_Query_HalogenM.monadAffHalogenM(dictMonadAff))(Effect_Aff.killFiber(Effect_Exception.error("Time's up!"))(ref.value0.fiber))))(function () {
                                                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Effect_Aff_Class.liftAff(Halogen_Query_HalogenM.monadAffHalogenM(dictMonadAff))(Effect_Aff.forkAff(Control_Bind.discard(Control_Bind.discardUnit)(Effect_Aff.bindAff)(Effect_Aff.delay(st.debounceTime))(function () {
                                                            return Effect_Aff_AVar.put(Data_Unit.unit)(ref["value0"]["var"]);
                                                        }))))(function (fiber) {
                                                            return Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Data_Foldable.traverse_(Effect.applicativeEffect)(Data_Foldable.foldableMaybe)(Effect_Ref.write(new Data_Maybe.Just({
                                                                "var": ref["value0"]["var"],
                                                                fiber: fiber
                                                            })))(st.debounceRef)));
                                                        });
                                                    });
                                                };
                                                return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                                            });
                                        });
                                    });
                                });
                            };
                            if (v instanceof Highlight) {
                                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (st) {
                                    return Control_Applicative.when(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Eq.eq(eqVisibility)(st.visibility)(On.value))(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v1) {
                                        var $53 = {};
                                        for (var $54 in v1) {
                                            if ({}.hasOwnProperty.call(v1, $54)) {
                                                $53[$54] = v1[$54];
                                            };
                                        };
                                        $53.highlightedIndex = Data_Maybe.Just.create(getTargetIndex(st)(v.value0));
                                        return $53;
                                    }));
                                });
                            };
                            if (v instanceof Select) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Data_Foldable.for_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(v.value1)((function () {
                                    var $80 = Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()));
                                    return function ($81) {
                                        return $80(Web_Event_Event.preventDefault(Web_UIEvent_MouseEvent.toEvent($81)));
                                    };
                                })()))(function () {
                                    return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (st) {
                                        return Control_Applicative.when(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Eq.eq(eqVisibility)(st.visibility)(On.value))((function () {
                                            if (v.value0 instanceof Index) {
                                                return handleEvent(new Selected(v.value0.value0));
                                            };
                                            if (v.value0 instanceof Next) {
                                                return handleEvent(Selected.create(getTargetIndex(st)(v.value0)));
                                            };
                                            if (v.value0 instanceof Prev) {
                                                return handleEvent(Selected.create(getTargetIndex(st)(v.value0)));
                                            };
                                            throw new Error("Failed pattern match at Select (line 274, column 32 - line 277, column 64): " + [ v.value0.constructor.name ]);
                                        })());
                                    });
                                });
                            };
                            if (v instanceof ToggleClick) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Web_Event_Event.preventDefault(Web_UIEvent_MouseEvent.toEvent(v.value0))))(function () {
                                    return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (st) {
                                        if (st.visibility instanceof On) {
                                            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(handle(new Focus(false)))(function () {
                                                return handle(new SetVisibility(Off.value));
                                            });
                                        };
                                        if (st.visibility instanceof Off) {
                                            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(handle(new Focus(true)))(function () {
                                                return handle(new SetVisibility(On.value));
                                            });
                                        };
                                        throw new Error("Failed pattern match at Select (line 282, column 5 - line 288, column 34): " + [ st.visibility.constructor.name ]);
                                    });
                                });
                            };
                            if (v instanceof Focus) {
                                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query.getHTMLElementRef("select-input"))(function (inputElement) {
                                    return Data_Foldable.for_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(inputElement)(function (el) {
                                        return Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))((function () {
                                            if (v.value0) {
                                                return Web_HTML_HTMLElement.focus(el);
                                            };
                                            return Web_HTML_HTMLElement.blur(el);
                                        })());
                                    });
                                });
                            };
                            if (v instanceof Key) {
                                return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Data_Functor["void"](Halogen_Query_HalogenM.functorHalogenM)(Halogen_Query_HalogenM.fork(handle(new SetVisibility(On.value)))))(function () {
                                    var preventIt = Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Web_Event_Event.preventDefault(Web_UIEvent_KeyboardEvent.toEvent(v.value0)));
                                    var v1 = Web_UIEvent_KeyboardEvent.key(v.value0);
                                    if (v1 === "ArrowUp" || v1 === "Up") {
                                        return Control_Apply.applySecond(Halogen_Query_HalogenM.applyHalogenM)(preventIt)(handle(new Highlight(Prev.value)));
                                    };
                                    if (v1 === "ArrowDown" || v1 === "Down") {
                                        return Control_Apply.applySecond(Halogen_Query_HalogenM.applyHalogenM)(preventIt)(handle(new Highlight(Next.value)));
                                    };
                                    if (v1 === "Escape" || v1 === "Esc") {
                                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Halogen_Query.getHTMLElementRef("select-input"))(function (inputElement) {
                                            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(preventIt)(function () {
                                                return Data_Foldable.for_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(inputElement)((function () {
                                                    var $82 = Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()));
                                                    return function ($83) {
                                                        return $82(Web_HTML_HTMLElement.blur($83));
                                                    };
                                                })());
                                            });
                                        });
                                    };
                                    if (v1 === "Enter") {
                                        return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (st) {
                                            return Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(preventIt)(function () {
                                                return Data_Foldable.for_(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Foldable.foldableMaybe)(st.highlightedIndex)(function (ix) {
                                                    return handle(new Select(new Index(ix), Data_Maybe.Nothing.value));
                                                });
                                            });
                                        });
                                    };
                                    return Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit);
                                });
                            };
                            if (v instanceof PreventClick) {
                                return Effect_Class.liftEffect(Halogen_Query_HalogenM.monadEffectHalogenM(dictMonadAff.MonadEffect0()))(Web_Event_Event.preventDefault(Web_UIEvent_MouseEvent.toEvent(v.value0)));
                            };
                            if (v instanceof SetVisibility) {
                                return Control_Bind.bind(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.get(Halogen_Query_HalogenM.monadStateHalogenM))(function (st) {
                                    return Control_Applicative.when(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Eq.notEq(eqVisibility)(st.visibility)(v.value0))(Control_Bind.discard(Control_Bind.discardUnit)(Halogen_Query_HalogenM.bindHalogenM)(Control_Monad_State_Class.modify_(Halogen_Query_HalogenM.monadStateHalogenM)(function (v2) {
                                        var $68 = {};
                                        for (var $69 in v2) {
                                            if ({}.hasOwnProperty.call(v2, $69)) {
                                                $68[$69] = v2[$69];
                                            };
                                        };
                                        $68.visibility = v.value0;
                                        $68.highlightedIndex = new Data_Maybe.Just(0);
                                        return $68;
                                    }))(function () {
                                        return handleEvent(new VisibilityChanged(v.value0));
                                    }));
                                });
                            };
                            if (v instanceof Action) {
                                return handleAction$prime(v.value0);
                            };
                            throw new Error("Failed pattern match at Select (line 224, column 42 - line 324, column 34): " + [ v.constructor.name ]);
                        };
                    };
                };
            };
        };
    };
};
var ordVisibility = new Data_Ord.Ord(function () {
    return eqVisibility;
}, function (x) {
    return function (y) {
        if (x instanceof Off && y instanceof Off) {
            return Data_Ordering.EQ.value;
        };
        if (x instanceof Off) {
            return Data_Ordering.LT.value;
        };
        if (y instanceof Off) {
            return Data_Ordering.GT.value;
        };
        if (x instanceof On && y instanceof On) {
            return Data_Ordering.EQ.value;
        };
        throw new Error("Failed pattern match at Select (line 86, column 1 - line 86, column 48): " + [ x.constructor.name, y.constructor.name ]);
    };
});
var eqTarget = new Data_Eq.Eq(function (x) {
    return function (y) {
        if (x instanceof Prev && y instanceof Prev) {
            return true;
        };
        if (x instanceof Next && y instanceof Next) {
            return true;
        };
        if (x instanceof Index && y instanceof Index) {
            return x.value0 === y.value0;
        };
        return false;
    };
});
var defaultSpec = {
    render: Data_Function["const"](Halogen_HTML_Core.text(Data_Monoid.mempty(Data_Monoid.monoidString))),
    handleAction: Data_Function["const"](Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit)),
    handleQuery: Data_Function["const"](Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Maybe.Nothing.value)),
    handleEvent: Data_Function["const"](Control_Applicative.pure(Halogen_Query_HalogenM.applicativeHalogenM)(Data_Unit.unit)),
    receive: Data_Function["const"](Data_Maybe.Nothing.value),
    initialize: Data_Maybe.Nothing.value,
    finalize: Data_Maybe.Nothing.value
};
var component = function (dictMonadAff) {
    return function (dictLacks) {
        return function (dictLacks1) {
            return function (dictLacks2) {
                return function (mkInput) {
                    return function (spec) {
                        var initialState = (function () {
                            var pipeline = Control_Semigroupoid.composeFlipped(Record_Builder.semigroupoidBuilder)(Record_Builder.modify()()(new Data_Symbol.IsSymbol(function () {
                                return "search";
                            }))(Data_Symbol.SProxy.value)(Data_Maybe.fromMaybe("")))(Control_Semigroupoid.composeFlipped(Record_Builder.semigroupoidBuilder)(Record_Builder.modify()()(new Data_Symbol.IsSymbol(function () {
                                return "debounceTime";
                            }))(Data_Symbol.SProxy.value)(Data_Maybe.fromMaybe(Data_Monoid.mempty(Data_Time_Duration.monoidMilliseconds))))(Control_Semigroupoid.composeFlipped(Record_Builder.semigroupoidBuilder)(Record_Builder.insert()()(new Data_Symbol.IsSymbol(function () {
                                return "debounceRef";
                            }))(Data_Symbol.SProxy.value)(Data_Maybe.Nothing.value))(Control_Semigroupoid.composeFlipped(Record_Builder.semigroupoidBuilder)(Record_Builder.insert()()(new Data_Symbol.IsSymbol(function () {
                                return "visibility";
                            }))(Data_Symbol.SProxy.value)(Off.value))(Record_Builder.insert()()(new Data_Symbol.IsSymbol(function () {
                                return "highlightedIndex";
                            }))(Data_Symbol.SProxy.value)(Data_Maybe.Nothing.value)))));
                            return Record_Builder.build(pipeline);
                        })();
                        return Halogen_Component.mkComponent({
                            initialState: function ($84) {
                                return initialState(mkInput($84));
                            },
                            render: spec.render,
                            "eval": Halogen_Component.mkEval({
                                handleQuery: handleQuery(dictMonadAff)(spec.handleQuery),
                                handleAction: handleAction(dictMonadAff)()()()(spec.handleAction)(spec.handleEvent),
                                initialize: new Data_Maybe.Just(new Initialize(spec.initialize)),
                                receive: (function () {
                                    var $85 = Data_Functor.map(Data_Maybe.functorMaybe)(Action.create);
                                    return function ($86) {
                                        return $85(spec.receive($86));
                                    };
                                })(),
                                finalize: Data_Functor.map(Data_Maybe.functorMaybe)(Action.create)(spec.finalize)
                            })
                        });
                    };
                };
            };
        };
    };
};
module.exports = {
    Search: Search,
    Highlight: Highlight,
    Select: Select,
    ToggleClick: ToggleClick,
    Focus: Focus,
    Key: Key,
    PreventClick: PreventClick,
    SetVisibility: SetVisibility,
    Initialize: Initialize,
    Action: Action,
    Send: Send,
    Query: Query,
    Searched: Searched,
    Selected: Selected,
    VisibilityChanged: VisibilityChanged,
    Prev: Prev,
    Next: Next,
    Index: Index,
    Off: Off,
    On: On,
    Text: Text,
    Toggle: Toggle,
    defaultSpec: defaultSpec,
    component: component,
    handleQuery: handleQuery,
    handleAction: handleAction,
    eqTarget: eqTarget,
    eqVisibility: eqVisibility,
    ordVisibility: ordVisibility
};
